import { api } from '../apiConfig';
import { shopifyService } from './shopifyService';

export async function getShippingLabels() {
  const response = await api.get('/shipping/labels');
  return response.data;
}

export async function getShippingQueue() {
  const response = await api.get('/shipping/queue');
  return response.data;
}

export async function createShippingLabel(labelData) {
  const response = await api.post('/shipping/labels', labelData);
  return response.data;
}

export async function getShippingRates(shipmentData) {
  try {
    console.log('🚚 Getting shipping rates from backend (using real Shopify Admin API)...');
    
    // Use backend with real Shopify Admin API calls
      const response = await api.post('/shipping/rates', shipmentData);
      return response.data;
    
  } catch (error) {
    console.error('❌ Error getting shipping rates:', error);
    const apiMessage = error.response?.data?.message
      || error.response?.data?.error
      || error.message
      || 'Unable to retrieve shipping rates';
    const err = new Error(apiMessage);
    err.hints = error.response?.data?.hints;
    err.carrierErrors = error.response?.data?.carrier_errors;
    throw err;
  }
}

// Development helper function
export async function addSampleShipment() {
  const response = await api.post('/shipping/dev/sample');
  return response.data;
} 